export default __webpack_public_path__ + "static/media/gastro_3.1d444d46.jpg";